import { CMS_API_URL } from "./constants";

// Fetch a page's PUBLISHED content from the CMS. Returns null on 404
// (page never published) or any network/parse error, so callers fall back
// to their baked-in default content and the site never breaks on an API
// hiccup.
export async function fetchPublishedContent<T>(slug: string): Promise<T | null> {
  try {
    const res = await fetch(`${CMS_API_URL}/cms/pages/${slug}`, {
      headers: { Accept: "application/json" },
      cache: "no-store",
    });
    if (!res.ok) return null;
    return (await res.json()) as T;
  } catch {
    return null;
  }
}
